







































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, HSL, Name, NameData } from "../models";
import { paletteGenerator } from "../utils/paletteGenerator";
import {
  mdiDiceMultiple,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiCheck,
  mdiClose
} from "@mdi/js";
import GenderIcon from "../components/GenderIcon.vue";
import NameStreamGraph from "../components/NameStreamGraph.vue";

@Component({
  components: {
    GenderIcon,
    NameStreamGraph
  }
})
export default class NameCard extends Vue {
  @Prop() name!: NameData;
  @Prop({ default: false }) flat: boolean;

  tickIcon = mdiCheck;
  crossIcon = mdiClose;

  @Prop({ default: 2010 }) minYear!: number;
  @Prop({ default: 2015 }) maxYear!: number;

  get nameData() {
    return [this.name as Name, this.name.data];
  }

  get svgHeight() {
    if (!this.$el) return null;
    const graphContainer = this.$el.querySelector(".graphContainer");
    if (!graphContainer) return null;

    return graphContainer.getBoundingClientRect().height;
  }

  get graphHeight() {
    const { graph } = this.$refs;
    if (!graph) return null;
    return graph as Element;
  }

  get mostRecentYear() {
    if (!this.name.data) return null;
    const datapoints = this.name.data;
    const sortedYears = datapoints.sort((a, b) => (a.year < b.year ? 1 : -1));
    return sortedYears[0];
  }
}
